<template>
  <v-autocomplete
    v-model="selectedLocations"
    :items="yelpItems"
    return-object
    item-text="name" 
    item-value="id"
    :loading="isLoading"
    :search-input.sync="search"
    chips deletable-chips
    hide-selected hide-no-data multiple clearable
    :error="error" :hint="hint"
    cache-items open-on-clear
    :disabled="disabled" label="Search for a nearby location..."
    @change="onSuggestionLocationsUpdated()"
  >
    <template slot="no-data">
      <v-list-tile>
        <v-list-tile-title>Search for a <strong>place</strong></v-list-tile-title>
      </v-list-tile>
    </template>

    <template slot="selection" slot-scope="{item, selected}">
      <v-chip :selected="selected" color="blue-grey" class="white--text">
        <v-icon>place</v-icon>
        <span v-text="item.name"></span>
      </v-chip>
    </template>

    <template slot="item" slot-scope="{item, tile}">
      <!-- This is for the tile when showing items -->
      <v-list-tile-avatar color="primary" class="headline font-weight-light white--text">
        {{ item.name.charAt(0) }}
      </v-list-tile-avatar>
      
      <v-list-tile-content>
        <v-list-tile-title v-text="item.name"></v-list-tile-title>
        <v-list-tile-sub-title v-text="item.Description"></v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-list-tile-action-text v-text="item.price"></v-list-tile-action-text>
        <v-list-tile-action-text>
          <v-rating v-model="item.rating" color="yellow darken-3" half-increments readonly dense small></v-rating>
        </v-list-tile-action-text>
      </v-list-tile-action>
    </template>

  </v-autocomplete>
</template>

<script>
  import axios from 'axios'
  // var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

  import _ from 'lodash'

  export default {
    name: 'Suggestions',
    props: {
      disabled: {
        type: Boolean, 
        default: false
      }, 
      label: {
        type: String, 
      }
    },
    data() {
      return {
        yelpEntries: [],
        fourSquareEntries: [],
        descriptionLimit: 25,
        isLoading: false,
        selectedLocations: [], 
        search: null, 
        geolocationOptions: {},
        geolocation: {}, 
        error: false,
        hint: '',
        mapboxEntries: [],
      }
    }, 
    computed:{
      items(){
        return this.mapboxEntries.map(entry => {
          const Description = entry.place_name.length > this.descriptionLimit
            ? entry.place_name.slice(0, this.descriptionLimit) + '...'
            : entry.place_name
          return Object.assign({}, entry, { Description })
        })
      },
      yelpItems(){
        return this.yelpEntries.map(entry => {
          const Description = entry.location.display_address.join(' ').length > this.descriptionLimit
            ? entry.location.display_address.join(' ').slice(0, this.descriptionLimit) + '...'
            : entry.location.display_address.join(' ')
          return Object.assign({}, entry, { Description })
        })
      }
    },
    watch: {
      search(val){
        this.debouncedGetYelpLocations()
      }, 
    },
    mounted: function() {
      this.updateGeolocation( (geolocation,position) => {
        this.getFoursquareLocations(position);
      });
    }, 
    created(){
      this.debouncedGetYelpLocations = _.debounce(this.getYelpLocations, 450)
    },
    methods: { 
      onSuggestionLocationsUpdated(){
        //Emit an event with the array of locations
        this.$emit('suggestionsupdated', this.selectedLocations.map( (item) => {return this.formatYelpLocation(item)}) )
      },
      formatYelpLocation(yelpLocation){
        let returnYelpLocation = {}
        returnYelpLocation.id = yelpLocation.id
        returnYelpLocation.name = yelpLocation.name
        returnYelpLocation.distance = yelpLocation.distance
        returnYelpLocation.review_count = yelpLocation.review_count
        returnYelpLocation.rating = yelpLocation.rating
        returnYelpLocation.location = yelpLocation.coordinates
        returnYelpLocation.address = yelpLocation.location.display_address.join(' ')

        return returnYelpLocation;
      },
      getYelpLocations(){
        if (this.search == null || this.search.length < 4 || this.geolocation == null) {
          this.error = false
          this.hint = 'Please type more or ensure you\'ve allowed access to location'
          return;
        } else if (this.search.length <= 0) {
          this.error = false
          this.hint = ''
        }
        else {
          this.error = false
          this.hint = ''
        }

        this.isLoading = true

        let query = encodeURI(this.search.replace(' ', '+'))
        
        let yelpData = { data: {
          text: query, 
          latitude: this.geolocation.loc.lat, 
          longitude: this.geolocation.loc.lng
        }}

        axios.post('https://us-central1-zoomryde.cloudfunctions.net/Suggestions', yelpData, 
          {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            const {businesses} = res.data.result.data
            this.yelpEntries = businesses
          })
          .finally(() => {
            this.isLoading = false
          })
      }, 
      getFoursquareLocations(position = null){
        if (position == null) {
          return;
        } else {
          let fsData = { data: {
            latitude: this.geolocation.loc.lat, 
            longitude: this.geolocation.loc.lng
          }}

          axios.post('https://us-central1-zoomryde.cloudfunctions.net/LocalRecommendations', fsData, 
            {
              headers: {
                'Content-Type': 'application/json'
              }
            })
          .then(res => {
            console.log(res);
            const {groups} = res.data.result.data.response;
            this.fourSquareEntries = groups
            // const {businesses} = res.data.result.data
            // this.fourSquareEntries = businesses
          })
          .finally(() => {
            this.isLoading = false
          })
        }
      },
      getLocations(){
        if (this.search == null || this.search.length < 4) return

        this.isLoading = true
        let types = this.type_toggle.join(',')
        let query = encodeURI(this.search.replace(' ', '+'))

        axios.get('https://api.mapbox.com/geocoding/v5/mapbox.places/'+query+'.json?country=jp&limit=5&types='+types+'&language=en&access_token=pk.eyJ1IjoianVzdGlubXNoZXAiLCJhIjoiY2pndWU4d3F4MjBpMDJ5bWw0eGY0NWd4NyJ9.A74zFyt3xEDTM_4R_oE7nw')
          .then(res => { 
            const {features} = res.data
            this.mapboxEntries = features
          })
          .catch(error => {
            console.log(error)
          })
      }, 
      /**
       * Update internal location from navigator geolocation
       * @param  {Function} (geolocation, position)
       */
      updateGeolocation (callback = null) {
        if (navigator.geolocation) {
          let options = {
            enableHighAccuracy: true
          };

          if(this.geolocationOptions) Object.assign(options, this.geolocationOptions);

          navigator.geolocation.getCurrentPosition(position => {
              let geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              
              this.geolocation.loc = geolocation;
              this.geolocation.position = position;
              
              if (callback) callback(geolocation, position);
            }, err => {
                this.$emit('error', 'Cannot get Coordinates from navigator', err);
            }, options);
        }
      },
    }, 
  }
</script>

<style>
</style>